<template>
  <div class="card-box">
    <div class="card-box_title">
      <span>{{ title }}</span>
      <a class="text-click" @click="goList(type, title)">更多 +</a>
    </div>
    <div
      class="card-box_img"
      @click="goDetail(list[0].id, type, list[0].type, list[0].linkUrl)"
    >
      <img
        v-if="list[0]?.coverImgMax"
        :src="`${baseUrl}/${list[0].coverImgMax}`"
        alt=""
      />
      <div class="text-ellipsis">{{ list[0]?.title }}</div>
    </div>
    <ul class="card-box_list">
      <li v-for="item in list.slice(1)" :key="item.id">
        <span>●</span>
        <div
          class="text-click"
          @click="goDetail(item.id, type, item.type, item.linkUrl)"
        >
          {{ item.title }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { goDetail, goList, openView } from '@/utils';
export default {
  name: 'homeCard',
  props: {
    title: String,
    type: String,
    list: Array,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_BASE_URL,
    };
  },
  methods: {
    goDetail,
    goList,
  },
};
</script>

<style lang="scss" scoped>
.card-box {
  &_title {
    height: 30px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    border-bottom: 4px solid #ebebeb;
    span {
      text-align: center;
      font-weight: normal;
      font-size: 18px;
      height: 30px;
      border-bottom: 4px solid #d9251e;
    }
    a {
      font-size: 14px;
      color: #000;
      line-height: 30px;
    }
  }
  &_img {
    position: relative;
    margin-bottom: 16px;
    color: #fff;
    overflow: hidden;
    cursor: pointer;
    &:hover {
      img {
        transform: scale(1.2);
      }
      .text-ellipsis {
        background: rgba(217, 37, 30, 0.4);
      }
    }
    img {
      width: 100%;
      height: 220px;
      transition: all 0.6s;
    }
    .text-ellipsis {
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
      padding: 0 20px;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      background: rgba(0, 0, 0, 0.6);
    }
  }
  &_list {
    li {
      margin-top: 16px;
      span {
        color: #ebebeb;
        margin-right: 10px;
      }
      font-size: 14px;
      display: flex;
      justify-content: flex-start;
    }
  }
}
</style>
